// @flow
import React from 'react';
import tickIcon from 'assets/images/tick-red.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  title: string,
  subTitle?: string,
  imageUrl: string,
  isActive?: boolean,
  onClick: () => void,
};

export const SearchFilterItem = (props: Props) => {
  const {
    title,
    subTitle,
    imageUrl,
    isActive = false,
    onClick,
    isArtistSearch = false,
  } = props;

  return (
    <div
      className={
        isArtistSearch ? 'artist search-filter-item' : 'search-filter-item'
      }
      onClick={onClick}
    >
      {isActive && (
        <div className={'tick-icon'}>
          <img src={tickIcon} alt={'icon'} />
        </div>
      )}
      <div className={'image-container'}>
        <img src={imageUrl} alt={'search result'} />
      </div>
      <div className={'title-container'}>
        <h4>{title}</h4>
        {subTitle && <span>{subTitle}</span>}
      </div>
    </div>
  );
};
